export default __webpack_public_path__ + "fca12f26ae9418780f8405ef9afc5f1b.svg";